import { testimonials } from '@/mocks/posts';

export default function TestimonialSection() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-accent-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-12">
          <span className="inline-flex items-center gap-1.5 text-xs font-label tracking-[0.2em] text-accent-800 uppercase mb-3">
            <i className="ri-subtract-line" />
            网友怎么说
          </span>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">省时间，也看得明白</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-700 leading-7">
            我们收到最多的反馈不是"内容多"，而是"终于不用自己拉进度条了"。这大概就是看点整理存在的意义。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex flex-col h-full bg-background-50 rounded-lg p-6 border border-accent-200"
            >
              <div className="flex items-center gap-1 text-accent-600 mb-4">
                {[0, 1, 2, 3, 4].map((star) => (
                  <i key={star} className="ri-star-fill text-sm" />
                ))}
              </div>
              <blockquote className="flex-1 text-sm text-foreground-700 leading-7">“{item.text}”</blockquote>
              <figcaption className="mt-6 pt-4 border-t border-background-200 flex items-center gap-3">
                <div className="w-11 h-11 shrink-0 overflow-hidden rounded-full bg-background-200">
                  <img
                    src={item.avatar}
                    alt={`${item.name}的头像`}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{item.name}</div>
                  <div className="text-xs text-foreground-500">{item.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}